import API from "./api";

/**
 * BBPS Service for Admin Portal
 */

export const getAdminMasterBbpsCategories = async () => {
  const res = await API.get("/bbps/admin/master-categories");
  return res.data;
};

export const updateGlobalBbpsCategories = async (globalSettings) => {
  const res = await API.put("/bbps/admin/global-categories", { globalSettings });
  return res.data;
};

export const getPropertyBbpsCategories = async (societyId) => {
  const res = await API.get(`/bbps/admin/property/${societyId}/categories`);
  return res.data;
};

export const updatePropertyBbpsCategories = async (societyId, payload) => {
  const res = await API.put(`/bbps/admin/property/${societyId}/categories`, payload);
  return res.data;
};

export const getResolvedBbpsCategories = async (societyId = null) => {
  const params = societyId ? { society_id: societyId } : {};
  const res = await API.get("/bbps/categories", { params });
  return res.data;
};
